import { render, staticRenderFns } from "./StudentAssistantsPage.vue?vue&type=template&id=3b3a4f13&scoped=true"
import script from "./StudentAssistantsPage.vue?vue&type=script&lang=js"
export * from "./StudentAssistantsPage.vue?vue&type=script&lang=js"
import style0 from "./StudentAssistantsPage.vue?vue&type=style&index=0&id=3b3a4f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a4f13",
  null
  
)

export default component.exports